import "./podweb.style.css";

export function Podweb() {
    return (
        <div style={{ padding: "0px 32px" }}>
            <h1 style={{ marginBottom: "16px" }}>The Podweb Browser</h1>
            <p>
                I created this as a cozy part of the internet — living on the fantasy console{" "}
                <a href="https://www.lexaloffle.com/picotron.php" target="_blank" rel="noreferrer">
                    Picotron
                </a>
                .
            </p>
            <p>
                Picotron is a fantasy workstation by Zep — the creator of the beloved PICO-8.
                It's a self-contained creative environment where you can write code, make music, draw
                sprites, and build entire applications, all within a tiny simulated OS running in your
                browser or on desktop. The Podweb is a small web-like network that lives entirely
                inside Picotron: sites are called <em>pods</em>, they're hand-crafted by the community,
                and you browse them with a built-in browser — all running on a fantasy machine.
            </p>
            <p>
                Below you can explore the Podweb directly in your browser, no Picotron installation needed.
            </p>
            <div className="podweb-iframe-wrapper">
                <div className="podweb-iframe-container">
                    <iframe
                        src="https://www.lexaloffle.com/bbs/widget.php?pid=podnet_browser"
                        allowFullScreen
                        title="Podweb Browser"
                    />
                </div>
            </div>
            <p className="podweb-narrow-message">
                To use the Podweb Browser please view on a wider screen.
            </p>
        </div>
    );
}
